import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../CSS/Courses.css';
import TopperCard from './TopperCard';
import { getAllToppers } from '../firebase/firestoreService';

const SCIENCE_COURSES = ['JEE', 'NEET', 'MH-CET'];

const CoursesScience = () => {
  const [toppers, setToppers] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getAllToppers()
      .then(data => setToppers(data.filter(t => SCIENCE_COURSES.includes(t.course))))
      .catch(() => {});
  }, []);

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Course",
        "name": "JEE NEET MH-CET Coaching in Ulhasnagar — Class 11 & 12 Science",
        "description": "Expert JEE, NEET and MH-CET coaching for Class 11 and 12 science students in Ulhasnagar and Kalyan. 21+ years of results at Nalanda Group Tuitions.",
        "provider": { "@type": "EducationalOrganization", "name": "Nalanda Group Tuitions", "url": "https://nalandagrouptuitions.com" }
      }) }} />

      <div className="ngt-page-banner">
        <h1>JEE, NEET &amp; MH-CET Coaching in Ulhasnagar — Class 11 &amp; 12 Science</h1>
        <p>Best Science Coaching · IIT · AIIMS · MH-CET · Nalanda Group Tuitions</p>
      </div>

      <nav aria-label="breadcrumb" className="container mt-3">
        <ol className="breadcrumb" style={{ fontSize: '0.85rem' }}>
          <li className="breadcrumb-item"><a href="/">Home</a></li>
          <li className="breadcrumb-item">Courses</li>
          <li className="breadcrumb-item active">JEE / NEET / MH-CET Coaching Ulhasnagar</li>
        </ol>
      </nav>

      <section className="ngt-course-detail-page">
        <div className="container">
          <div className="row g-5 align-items-start">
            <div className="col-lg-8">
              <div className="ngt-card">
                <h2 style={{ fontFamily: 'Playfair Display,serif', color: 'var(--ngt-navy)', marginBottom: '1rem' }}>
                  11th &amp; 12th Science — JEE / NEET / MH-CET Coaching in Ulhasnagar
                </h2>
                <p style={{ color: 'var(--ngt-grey)' }}>
                  NGT's <strong>science coaching programme for Class 11 and 12</strong> is designed for students
                  targeting <strong>IIT JEE, NEET, MH-CET, AIIMS, IISER</strong> and other top engineering and
                  medical entrance examinations. Our faculty includes subject specialists in Physics, Chemistry,
                  and Biology / Mathematics who combine board syllabus mastery with competitive exam preparation.
                </p>
                <hr className="ngt-divider" />
                <h3 style={{ color: 'var(--ngt-navy)', fontSize: '1.1rem', marginBottom: '0.8rem' }}>Exams We Prepare For</h3>
                <ul style={{ color: 'var(--ngt-grey)', paddingLeft: '1.4rem', lineHeight: '2' }}>
                  <li><strong>JEE Mains &amp; Advanced</strong> — IIT, NIT, BITS and top engineering colleges</li>
                  <li><strong>NEET</strong> — MBBS, BDS, and other medical entrance</li>
                  <li><strong>MH-CET</strong> — Maharashtra state engineering and pharmacy</li>
                  <li><strong>AIIMS / IISER / KVPY</strong> — research and medical institutions</li>
                  <li>HSC Board (Maharashtra / CBSE) — Class 11 &amp; 12 Science</li>
                </ul>
                <hr className="ngt-divider" />
                <h3 style={{ color: 'var(--ngt-navy)', fontSize: '1.1rem', marginBottom: '0.8rem' }}>What Is Covered</h3>
                <ul style={{ color: 'var(--ngt-grey)', paddingLeft: '1.4rem', lineHeight: '2' }}>
                  <li>Physics, Chemistry, Mathematics / Biology — complete syllabus</li>
                  <li>Regular DPPs (Daily Practice Problems) and chapter tests</li>
                  <li>Full-length mock tests in JEE / NEET / MH-CET pattern</li>
                  <li>In-house curated notes and formula sheets</li>
                  <li>Previous year paper analysis and rank prediction</li>
                </ul>
                <hr className="ngt-divider" />
                <div className="ngt-course-seo-block">
                  <h3>Best JEE, NEET &amp; MH-CET Coaching in Ulhasnagar</h3>
                  <p>
                    NGT is the <strong>best coaching institute for JEE and NEET in Ulhasnagar</strong>.
                    Our science faculty have guided hundreds of students to top ranks in IIT JEE,
                    NEET and MH-CET over 21+ years. If you are searching for <strong>MHT-CET coaching
                    near Kalyan</strong> or <strong>NEET coaching classes in Ulhasnagar</strong>, NGT
                    offers the most experienced faculty and proven preparation strategy in the region.
                  </p>
                  <div className="ngt-course-links" style={{ marginTop: '1rem' }}>
                    <span style={{ fontSize: '0.88rem', color: 'var(--ngt-grey)' }}>Also explore: </span>
                    <Link to="/ssc-coaching-ulhasnagar-kalyan">SSC Coaching</Link> ·{' '}
                    <Link to="/cbse-coaching-ulhasnagar-kalyan">CBSE Coaching</Link> ·{' '}
                    <Link to="/commerce-classes-ulhasnagar-kalyan">Commerce Classes</Link>
                  </div>
                </div>
              </div>

              {/* ── Science Toppers ── */}
              {toppers.length > 0 && (
                <div className="ngt-card mt-4">
                  <h3 style={{ fontFamily: 'Playfair Display,serif', color: 'var(--ngt-navy)', marginBottom: '1.2rem' }}>
                    <i className="fas fa-trophy me-2" style={{ color: '#b8860b' }}></i>JEE / NEET / MH-CET Toppers
                  </h3>
                  <div className="topper-scroll">
                    {toppers.map((t, i) => <TopperCard key={t.id || i} topper={t} />)}
                  </div>
                </div>
              )}
            </div>

            <div className="col-lg-4">
              <div className="ngt-enquiry-info">
                <h4>Enquire About JEE / NEET Coaching</h4>
                <p style={{ opacity: 0.85, fontSize: '0.92rem', marginBottom: '1.5rem' }}>
                  Ask about science batch timings, fees, and admissions for Class 11 and 12.
                </p>
                <Link to="/enquiry" className="btn-ngt-gold d-block text-center" style={{ marginBottom: '1rem' }}>Submit an Enquiry</Link>
                <a href="tel:+919272136659" className="btn-ngt-outline d-block text-center" style={{ color: '#fff', borderColor: '#fff' }}>
                  <i className="fas fa-phone me-1"></i> Call +91 9272136659
                </a>
                <hr style={{ borderColor: 'rgba(255,255,255,0.15)', margin: '1.5rem 0' }} />
                <div style={{ fontSize: '0.88rem', opacity: 0.8 }}>
                  <p><i className="fas fa-map-marker-alt me-2" style={{ color: 'var(--ngt-gold)' }}></i>Century Branch — Murbad Road, Ulhasnagar</p>
                  <p><i className="fas fa-map-marker-alt me-2" style={{ color: 'var(--ngt-gold)' }}></i>Khemani Branch, Ulhasnagar</p>
                  <p><i className="fas fa-clock me-2" style={{ color: 'var(--ngt-gold)' }}></i>Mon – Sat · 7:00 AM – 8:00 PM</p>
                  <p><i className="fas fa-envelope me-2" style={{ color: 'var(--ngt-gold)' }}></i>ngt.mailer@gmail.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CoursesScience;